import {
  GERMANY_BUILDING_NUMBER_ALLOWED_CHARACTERS,
  GERMANY_BUILDING_NUMBER_VALID_CHARACTERS,
  GERMANY_STREET_NAME_ALLOWED_CHARACTERS,
  GERMANY_STREET_NAME_VALID_CHARACTERS,
  maxLength,
  noConsecutiveSpaces,
  noWhiteStartOrEnd,
  required,
  validateAllowedCharacters
} from '@ps/web-shared-validators';
import type { Error } from '@ps/web-shared-validators';
import React from 'react';

import TextInput from '../../../../../../components/TextInput/TextInput';

import {
  TXTWCL_House_Number_cannot_be_longer__ELL,
  TXTWCL_House_number_5,
  TXTWCL_House_number_cannot_be_0X_00X__ELL,
  TXTWCL_If_not_applicable_please_enter_ELL,
  TXTWCL_Street_Name_cannot_be_longer_t_ELL,
  TXTWCL_Street_name_3
} from './StreetAddressExtendedDE.messages.json';

interface Props {
  disabled?: boolean;
}

const MAX_LENGTH_HOUSE_NUMBER = 20;
const MAX_LENGTH_STREET_NAME = 150;
const ONLY_ZEROS = /^0+$/;

const notAllZeros = (value: string): Error => ({
  valid: !!value && !ONLY_ZEROS.test(value),
  message: TXTWCL_House_number_cannot_be_0X_00X__ELL
});

const StreetAddressExtendedDE: React.FC<Props> = ({ disabled }) => (
  <>
    <TextInput
      id="streetName"
      label={TXTWCL_Street_name_3}
      disabled={disabled}
      validators={[
        required(TXTWCL_If_not_applicable_please_enter_ELL),
        noConsecutiveSpaces,
        noWhiteStartOrEnd,
        maxLength(MAX_LENGTH_STREET_NAME, {
          ...TXTWCL_Street_Name_cannot_be_longer_t_ELL,
          values: { 0: MAX_LENGTH_STREET_NAME }
        }),
        validateAllowedCharacters(
          GERMANY_STREET_NAME_ALLOWED_CHARACTERS,
          GERMANY_STREET_NAME_VALID_CHARACTERS
        )
      ]}
    />
    <TextInput
      id="buildingNumber"
      label={TXTWCL_House_number_5}
      disabled={disabled}
      validators={[
        required(TXTWCL_If_not_applicable_please_enter_ELL),
        notAllZeros,
        noWhiteStartOrEnd,
        noConsecutiveSpaces,
        maxLength(MAX_LENGTH_HOUSE_NUMBER, {
          ...TXTWCL_House_Number_cannot_be_longer__ELL,
          values: { 0: MAX_LENGTH_HOUSE_NUMBER }
        }),
        validateAllowedCharacters(
          GERMANY_BUILDING_NUMBER_ALLOWED_CHARACTERS,
          GERMANY_BUILDING_NUMBER_VALID_CHARACTERS
        )
      ]}
    />
  </>
);

export default StreetAddressExtendedDE;
